import Radium from "radium";
import React from "react";

import { styles } from "@common/styles";
import { Input } from "@components";

export interface IChangePasswordState {
  confirmNewPassword: string;
  newPassword: string;
  oldPassword: string;
}

export interface IChangePasswordActions {
  changePassword: (oldPassword: string, newPassword: string) => void;
}

class ChangePassword extends React.Component<
  IChangePasswordActions,
  IChangePasswordState
> {
  constructor(props) {
    super(props);

    this.state = {
      confirmNewPassword: "",
      newPassword: "",
      oldPassword: ""
    };
  }

  public render() {
    return (
      <div
        className="flexColumnContent"
        style={styles.flexColumnContent as any}
      >
        <div
          className="pageHeaderContainer"
          style={styles.pageHeaderContainer as any}
        >
          Endre passord
        </div>
        <div
          className="contentContainer"
          style={styles.contentContainer as any}
        >
          <div className="textContainer" style={styles.textContainer as any}>
            Skriv inn ditt gamle og ditt nye passord for å tilbakestille
            passordet ditt.
          </div>
          <Input
            name="oldPassword"
            label="Gammelt passord"
            value={this.state.oldPassword}
            type="password"
            onChange={oldPassword => this.setState({ oldPassword })}
            // style={{ maxWidth: "600px" }}
          />
          <Input
            name="newPassword"
            label="Nytt passord"
            value={this.state.newPassword}
            type="password"
            onChange={newPassword => this.setState({ newPassword })}
            // style={{ maxWidth: "600px" }}
          />
          <Input
            name="confirmNewPassword"
            label="Bekreft nytt passord"
            value={this.state.confirmNewPassword}
            type="password"
            onChange={confirmNewPassword =>
              this.setState({ confirmNewPassword })
            }
            // style={{ maxWidth: "600px" }}
          />
          <div
            className="buttonContainer"
            style={styles.buttonContainer as any}
          >
            <div style={styles.sendButtonContainer as any}>
              <button
                className="okButton"
                ref="okButton"
                style={styles.okButton as any}
                onClick={() => {
                  const {
                    confirmNewPassword,
                    newPassword,
                    oldPassword
                  } = this.state;
                  if (confirmNewPassword === newPassword) {
                    this.props.changePassword(oldPassword, newPassword);
                  }
                }}
              >
                Endre passord
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(ChangePassword);
